import React from 'react';
import { Box, Typography } from '@mui/material';
import logo from '../JN_Logo.png';

function QRCodeDisplay({ value,branchName, onClose }) {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        width: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 1000,
        backdropFilter: 'blur(5px)',
      }}
    >
      <Box
        sx={{
          backgroundColor: 'white',
          padding: { xs: 2, md: 3 }, // Adjust padding for mobile
          borderRadius: 2,
          boxShadow: 3,
          textAlign: 'center',
          width: { xs: '90%', sm: '70%', md: '28%' }, // Responsive width
        }}
      >
        <img
          src={logo}
          alt="Logo"
          style={{ margin: 'auto', width: '60px', maxWidth: '100%' }} // Adjust width for smaller screens
        />
        <Typography variant="h5" sx={{ color: 'cornflowerblue', lineHeight: 1, fontSize: { xs: 'large', sm: 'x-large', md: 'xx-large' } }}>
          <b>FAST CHECK-IN</b>
        </Typography>
        <Typography variant="h4" sx={{ color: 'cornflowerblue', fontSize: { xs: 'x-large', sm: 'xx-large', md: 'xxx-large' }, lineHeight: 1 }}>
          <b>SCAN ME!</b>
        </Typography>
        <Typography variant="h6"   sx={{ fontSize: { xs: 'medium', sm: 'large', md: 'x-large' }, lineHeight: 1.2 }}><b>{branchName}</b></Typography> 
        <img
          src={value}
          alt="QR Code"
          style={{
            margin: 'auto',
            border: '1px solid #cdcdcd',
            width: '80%',
            maxWidth: '256px',
            boxShadow: '2px',
          }}
        />

        <Typography variant="h6" mb={1} sx={{ fontSize: { xs: 'medium', sm: 'large', md: 'x-large' }, lineHeight: 1.2 }}>
          <b>Use Your Smartphone To</b>
          <br />
          <Typography variant="h1" sx={{ color: 'cornflowerblue', fontSize: { xs: 'xx-large', sm: 'xxx-large' }, lineHeight: 1 }}>
            Join the Queue
          </Typography>
        </Typography>

        <Typography
          variant="body1"
          sx={{ marginTop: 2, cursor: 'pointer', color: 'primary.main', fontSize: { xs: 'small', sm: 'medium' } }}
          onClick={onClose}
        >
          Close
        </Typography>
      </Box>
    </Box>
  );
}

export default QRCodeDisplay;
